import AppContainer from "./AppContainer";
import config, { AppConfig } from "./config";
import TestAppContainer from "../../tests/TestAppContainer";

let appContainer: AppContainer | undefined = undefined;

const getAppContainer = (): AppContainer => {
    if (!appContainer) {
        appContainer = createAppContainer(config);
    }

    return appContainer;
}

export const createAppContainer = (conf?: Partial<AppConfig>): AppContainer => {
    const c = { ...config, ...conf };
    return new AppContainer(c);
}

export const createTestAppContainer = (conf?: Partial<AppConfig>): TestAppContainer => {
    const c = { ...config, ...conf };
    const container = new TestAppContainer(c);
    return container;
}


export default getAppContainer;
